<template>
  <div>
    <draggable
      v-model="questions"
      group="questions"
      @start="drag = true"
      @end="drag = false"
      handle=".drag-handle"
    >
      <div
        class="test__question-item mb-3"
        v-for="(q, i) in questions"
        :key="q.id"
      >
        <b-card>
          <b-icon-list class="drag-handle" />
          <div
            class="test__question-header d-flex justify-content-between align-items-center"
          >
            <div class="title">
              <h6 class="mb-0">Запитання #{{ i + 1 }}</h6>
              <span :class="{ show: !show[i].show }">
                {{ q.text }}
              </span>
            </div>
            <div class="controls">
              <b-button
                size="sm"
                style="margin-right: 10px"
                variant="outline-danger"
                :id="'delete-' + i"
                @click="show_tooltip[i] = true"
              >
                <b-icon-trash />
              </b-button>
              <b-tooltip
                :target="'delete-' + i"
                :show.sync="show_tooltip[i]"
                triggers="click"
                placement="top"
                variant="danger"
                >Видалити?
                <a
                  href="#"
                  style="color: #fff"
                  @click.prevent="removeQuestion(i)"
                  >Так</a
                ></b-tooltip
              >
              <b-button size="sm" variant="link" @click="toggleCollape(i)">
                <span v-if="show[i].show"> <b-icon-chevron-up /></span>
                <span v-else>
                  <b-icon-chevron-down />
                </span>
              </b-button>
            </div>
          </div>

          <div class="collapsible" :class="{ opened: show[i].show }">
            <b-tabs content-class="mt-3" class="mt-3">
              <b-tab title="Питання" active>
                <div class="input-group mb-4">
                  <label class="d-block w-100">
                    <strong> Текст запитання</strong>
                  </label>
                  <b-form-textarea v-model="q.text" />
                </div>
                <label class="d-block w-100 mt-3">
                  <strong> Дескриптор</strong>
                </label>
                <b-form-group class="mb-4" v-slot="{ ariaDescribedby }">
                  <b-form-radio
                    v-for="d in descriptors"
                    :key="d.id"
                    v-model="q.descriptor"
                    :aria-describedby="ariaDescribedby"
                    :name="'question-' + i"
                    :value="d.id"
                    >{{ d.name }}</b-form-radio
                  >
                </b-form-group>
              </b-tab>
              <b-tab title="Варіанти відповіді" :disabled="q.type == 'writing'">
                <div class="answers">
                  <h5 class="mt-4">Варіанти відповіді</h5>
                  <div v-for="(a, j) in q.answers" :key="j + questions[i].id">
                    {{ questions[i].answers[j] }}
                    <b-input-group :prepend="letters[j]">
                      <b-form-input
                        v-model="questions[i].answers[j].text"
                      ></b-form-input>
                    </b-input-group>
                    <div class="d-flex mt-2">
                      <div class="type">
                        <label for=""><strong>Тип</strong></label>
                        <b-form-group
                          class="mb-4"
                          v-slot="{ ariaDescribedbyTwo }"
                        >
                          <b-form-radio
                            v-for="t in getTypes(questions[i].descriptor)"
                            :key="t"
                            v-model="questions[i].answers[j].type"
                            :aria-describedby="ariaDescribedbyTwo"
                            :name="'answers-' + i + '_' + j"
                            :value="t"
                            >{{ t }}</b-form-radio
                          >
                        </b-form-group>
                      </div>
                      <div class="points">
                        <label for="" class="d-block"
                          ><strong>Бали</strong></label
                        >
                        <input
                          type="text"
                          v-model.number="questions[i].answers[j].points"
                        />
                      </div>
                    </div>
                    <div class="border my-3"></div>
                  </div>

                  <div class="d-flex justify-content-end">
                    <b-button variant="link" @click="addAnswer(i)">
                      <b-icon-plus />
                      Додати варіант відповіді</b-button
                    >
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </b-card>
      </div>
      <div class="d-flex w-100 justify-content-end mt-3">
        <b-button size="sm" variant="success" @click="addQuestion"
          >Додати запитання</b-button
        >
      </div>
    </draggable>
  </div>
</template>

<script>
import draggable from "vuedraggable";
export default {
  components: {
    draggable,
  },
  props: ["questionsInput", "descriptorsInput"],
  data() {
    return {
      show: [],
      questions: [],
      key: 1,
      show_tooltip: [],
      descriptors: [],
      //Test constants
      letters: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"],
      //Templates
      new_question: {
        text: "",
        descriptor: null,
        answers: [],
      },
      new_answer: {
        text: "",
        type: null,
        points: 1,
      },
    };
  },
  methods: {
    getTypes(descriptor) {
      let types = [];
      let found = this.descriptorsInput.find((el) => {
        return el.id == descriptor;
      });
      if (found) {
        types = found.types;
      }
      console.log(found, descriptor);
      return types;
    },
    removeQuestion(i) {
      this.questions.splice(i, 1);
      this.show.splice(i, 1);
      this.show_tooltip.splice(i, 1);
    },
    addAnswer(i) {
      let answer = Object.assign({}, this.new_answer);
      answer["type"] = this.getTypes(this.questions[i].descriptor)[0];
      this.questions[i].answers.push(answer);
    },
    makeid(length) {
      var result = "";
      var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    },
    addQuestion() {
      let blank = Object.assign({}, this.new_question);
      blank["id"] = this.makeid(4);
      blank.descriptor = this.descriptorsInput[0].id;
      blank.answers = [];
      this.questions.push(blank);
      this.show.push({ show: true });
      this.show_tooltip.push(false);
    },
    toggleCollape(i) {
      console.log(i);
      if (this.show[i].show == true) {
        this.show[i].show = false;
      } else {
        this.show[i].show = true;
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.questions = this.questionsInput;

      this.questions.forEach(() => {
        this.show.push({ show: false });
        this.show_tooltip.push(false);
      });
      if (this.descriptorsInput) {
        this.descriptors = this.descriptorsInput;
        this.key++;
      }
      this.key++;
    }, 600);
  },
};
</script>

<style lang="scss" scoped>
.test {
  .remove-tooltip {
    color: #fff !important;
  }
  &__question-header {
    i {
      color: #ccc;
      font-size: 10px;
    }
  }
  .sortable-ghost {
    & > * {
      opacity: 0.1;
    }

    background: rgba(#e7e7e7, 0.5);
    border-radius: 12px;
    overflow: hidden;
    border: 1px dashed #ccc;
  }
  &__question-item {
    .card {
      padding-left: 30px;
      position: relative;
      .drag-handle {
        position: absolute;
        top: 50%;
        left: 10px;
        font-size: 20px;
        transform: translateY(-50%);
        color: #ccc;
        cursor: pointer;
      }
    }
  }
}
.collapsible {
  max-height: 0px;
  height: 0px;
  overflow: hidden;
  transition: 0.3s;
  padding: 0px 5px;
  &.opened {
    max-height: 1000px;
    height: auto;
    transition: 0.3s;
  }
}
.title {
  h6 {
    font-size: 14px;
  }
  span {
    font-size: 15px;
    opacity: 0;
    color: var(--primary-color);
    transition: 0.3s;
    &.show {
      transition: 0.3s;
      opacity: 1;
    }
  }
}
</style>
